import { HOME_FEATURE_ICONS } from "@/utils/home_feature_icons";

function memberships_enabled(features = {}) {
  return features.show_membership || features.show_memberships;
}

export function build_home_journey_cards(vm) {
  return [
  
    ...build_organization_cards(vm),
    ...build_profile_cards(vm),
    ...build_general_cards(vm),
    ...build_community_cards(vm),
  ];
}

function build_general_cards(vm) {
  const features = vm.active_features;


  return [
    {
      show: true,
      icon: 'bi-pencil-fill',
      icon_image: HOME_FEATURE_ICONS.post,
      title: 'Create a post',
      description: 'Make announcements.',
      action: 'Create Post',
      permission: 'posts',
      event: 'create-post',
    },
    {
      show: features.show_library,
      icon: 'bi-bookmark-fill',
      icon_image: HOME_FEATURE_ICONS.library,
      title: 'Use your library',
      description: 'Save useful documents from announcements.',
      action: 'Open Library',
      href: '/library',
    },
    {
      show: features.show_recent,
      icon: 'bi-clock-fill',
      icon_image: HOME_FEATURE_ICONS.recent_uploads,
      title: 'Review recent uploads',
      description: 'Find the newest documents and resources shared in your workspace.',
      action: 'Recent Uploads',
      href: '/view_recent_uploads',
    },
  ];
}

function build_community_cards(vm) {
  return [
    ...build_event_cards(vm),
    ...build_incident_cards(vm),
    ...build_community_engagement_cards(vm),
  ];
}

function build_event_cards(vm) {
  const features = vm.active_features;

  return [
    {
      show: features.show_events,
      icon: 'bi-calendar-event-fill',
      icon_image: HOME_FEATURE_ICONS.events,
      title: 'Discover events',
      description: 'From invitation to attendance.',
      action: 'View Events',
      href: '/view_events',
    },
  ];
}

function build_incident_cards(vm) {
  const features = vm.active_features;
  const asset_scope = vm.show_organisation_enabled ? 'community' : 'workspace';

  return [
    {
      show: features.show_incident,
      icon: 'bi-exclamation-triangle-fill',
      icon_image: HOME_FEATURE_ICONS.incident_reporting,
      title: 'Report an incident',
      description: 'Turn reports into action.',
      action: 'Incident Reporting',
      href: '/incident_reporting',
    },
    {
      show: features.show_assets && vm.can_manage_workspace,
      icon: 'bi-box-seam-fill',
      icon_image: HOME_FEATURE_ICONS.assets,
      title: 'Explore assets',
      description: `Access your ${asset_scope} assets.`,
      action: 'View Assets',
      href: '/community_asset',
    },
  ];
}

function build_community_engagement_cards(vm) {
  const features = vm.active_features;
  const audience_label = vm.show_organisation_enabled ? 'community' : 'workspace';

  return [
    {
      show: features.show_donations,
      icon: 'bi-piggy-bank-fill',
      icon_image: HOME_FEATURE_ICONS.donations,
      title: 'Donations & campaigns',
      description: `Turn support into impact`,
      action: 'View Donations',
      href: '/donation_campaigns',
    },
    {
      show: features.show_upcoming_birthdays,
      icon: 'bi-gift-fill',
      icon_image: HOME_FEATURE_ICONS.upcoming_birthdays,
      title: 'See upcoming birthdays',
      description: `Keep track of upcoming birthdays in your ${audience_label}.`,
      action: 'View Birthdays',
      href: '/view_all_birthdays',
    },
    {
      show: features.show_your_voice,
      icon: 'bi-chat-dots-fill',
      icon_image: HOME_FEATURE_ICONS.discussions,
      title: 'Community Voice',
      description: `Listen at ${audience_label} scale.`,
      action: 'Gather data',
      event: 'show-your-voice',
    },
  ];
}

function build_profile_cards(vm) {
  const features = vm.active_features;
  const audience_label = vm.show_organisation_enabled ? 'community' : 'workspace';


  return [
    {
      show: features.show_personal_profile,
      icon: 'bi-people-fill',
      icon_image: HOME_FEATURE_ICONS.personal_profile,
      title: 'Discover members',
      description: `Discover ${audience_label} members.`,
      action: 'View Profiles',
      href: '/view_personal_profiles',
    },
    {
      show: features.show_business_profile,
      icon: 'bi-building-fill',
      icon_image: HOME_FEATURE_ICONS.business_profile,
      title: 'Discover businesses',
      description: `Discover ${audience_label} businesses.`,
      action: 'View Businesses',
      href: '/view_business_profiles',
    },
  ];
}

function build_organization_cards(vm) {
  return [
    ...build_portal_cards(vm),
    ...build_business_cards(vm),
    ...build_membership_cards(vm),
  ];
}

function build_portal_cards(vm) {
  const portals_label_lower = vm.portals_label.toLowerCase();

  return [
    {
      show: vm.active_features.show_portals && vm.can_manage_workspace,
      icon: 'bi-grid-3x3-gap-fill',
      icon_image: HOME_FEATURE_ICONS.portals,
      title: `Create ${portals_label_lower}`,
      description: `Publish, organise and connect.`,
      action: `Create ${vm.portals_label}`,
      event: 'create-portal',
      permission: 'portals',
    },
  ];
}

function build_business_cards(vm) {
  const features = vm.active_features;
  return [
    {
      show: features.show_ads && vm.is_system_admin_user,
      icon: 'bi-megaphone-fill',
      title: 'Adverts & credits',
      description: 'Reach the right people.',
      action: 'Ads Centre',
      href: '/ads_center',
      permission: 'advertisements',
    },
    {
      show: features.show_marketplace,
      icon: 'bi-bag-fill',
      icon_image: HOME_FEATURE_ICONS.marketplace,
      title: 'Marketplace & orders',
      description: 'Build a community economy.',
      href: '/marketplace',
    },
    {
      show: vm.can_create_business_profile,
      icon: 'bi-briefcase-fill',
      icon_image: HOME_FEATURE_ICONS.business_profile,
      title: 'Create a business profile',
      description: 'Build your business presence.',
      action: 'Add Business',
      event: 'create-business-profile',
    },
  ];
}

function build_membership_cards(vm) {
  const features = vm.active_features;
  const show_memberships = memberships_enabled(features);

  return [
    {
      show: show_memberships && vm.can_manage_workspace,
      icon: 'bi-patch-check-fill',
      icon_image: HOME_FEATURE_ICONS.memberships,
      title: 'Memberships',
      description: 'Grow a committed community.',
      action: 'Memberships',
      href: vm.can_manage_organization ? '/organisation_create_membership' : '/create_membership',
      permission: 'membership',
    },
    {
      show: show_memberships && vm.is_standard_user,
      icon: 'bi-patch-check-fill',
      icon_image: HOME_FEATURE_ICONS.memberships,
      title: 'Memberships',
      description: 'Grow a committed community.',
      action: 'View Memberships',
      event: 'view-memberships',
    },
    {
      show: features.show_dynamic_forms && vm.can_manage_workspace,
      icon: 'bi-clipboard-check-fill',
      icon_image: HOME_FEATURE_ICONS.dynamic_forms,
      title: 'Build dynamic forms',
      description: 'Collect structured information.',
      action: 'Create Form',
      href: vm.can_manage_organization ? '/dynamic_forms_setup/' : '/create_form/',
      permission: 'dynamic_forms',
    },
  ];
}
